import { THEME_CLASS } from '@/lib/theme'
import { createContext, useContext, useEffect } from 'react'
import { useCookies } from 'react-cookie'

type ThemeContextType = [boolean, (isDarkMode: boolean) => void]

const initialState: ThemeContextType = [
  false,
  (_isDarkMode: boolean) => {
    return
  },
]

const Context = createContext(initialState as ThemeContextType)

type Props = {
  children: React.ReactNode
}


const ThemeProvider = ({ children }: Props) => {
  const [cookies, setCookies, removeCookie] = useCookies(['theme'])
  const setTheme = (theme: string) => {
    removeCookie('theme') // DO NOT DELETE - This removes old cookies that lack the path option (and break the theme switcher)
    setCookies('theme', theme, { path: '/' })
  }
  useEffect(() => {
    if (cookies.theme === undefined) {
      const isOsDarkMode = typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
      setTheme(isOsDarkMode ? 'dark' : 'light')
    }
  }, [])

  useEffect(() => {
    const isDark = cookies.theme === 'dark'
    if (isDark) document.body.classList.add(THEME_CLASS.dark)
    else document.body.classList.remove(THEME_CLASS.dark)
  }, [cookies.theme])
  return <Context.Provider value={[cookies.theme === 'dark', (isDarkMode: boolean) => setTheme(isDarkMode ? 'dark' : 'light')]}>{children}</Context.Provider>
}

export const useDarkMode = (): ThemeContextType => useContext(Context)
export default ThemeProvider